// 邮箱验证
export const emailReg = /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/
// 身份证验证
export const IDCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
// 手机号码验证
export const mobilePhoneReg = /^[1]([3-9])[0-9]{9}$/
